import { type InsuranceType } from '#app/components/insurance-section.tsx'

// Configuración para la sección "Seguros para personas"
export const segurosPersonas = [
	{
		id: 'auto',
		title: 'Auto',
		iconName: 'car-04',
		color: 'blue' as const,
		link: '/cotizasimple-auto',
	},
	{
		id: 'caucion',
		title: 'Caución General',
		iconName: 'document-validation',
		color: 'blue' as const,
		link: '/cotizacion-caucion-general',
	},
	{
		id: 'caucion-alquiler',
		title: 'Caución Alquiler',
		iconName: 'house-02',
		color: 'blue' as const,
		link: '/cotizacion-caucion-alquiler',
	},
	{
		id: 'moto',
		title: 'Moto',
		iconName: 'motorbike-02',
		color: 'blue' as const,
		link: '/cotizacion-general?tipo=Moto',
	},
	{
		id: 'hogar',
		title: 'Hogar',
		iconName: 'house-02',
		color: 'blue' as const,
		link: '/cotizacion-general?tipo=Hogar',
	},
	// {
	// 	id: 'accidentes-personales',
	// 	title: 'Accidentes personales',
	// 	iconName: 'user-shield-01',
	// 	color: 'blue' as const,
	// },
	// {
	// 	id: 'integral-comercio',
	// 	title: 'Integral de comercio',
	// 	iconName: 'package-delivered',
	// 	color: 'blue' as const,
	// },
	// {
	// 	id: 'planificacion-financiera',
	// 	title: 'Planificación financiera',
	// 	iconName: 'chart-evaluation',
	// 	color: 'blue' as const,
	// },
	// {
	// 	id: 'salud',
	// 	title: 'Salud',
	// 	iconName: 'healtcare',
	// 	color: 'blue' as const,
	// },
	// {
	// 	id: 'vida-retiro',
	// 	title: 'Vida y retiro',
	// 	iconName: 'user-sharing',
	// 	color: 'blue' as const,
	// },
] as InsuranceType[]

// Configuración para la sección "Seguros para empresas y pymes"
export const segurosEmpresas = [
	{
		id: 'art',
		title: 'ART',
		iconName: 'labor',
		color: 'green' as const,
		link: '/cotizacion-art',
	},
	// {
	// 	id: 'riegos-ambientales',
	// 	title: 'Riegos ambientales',
	// 	iconName: 'sun-cloud-angled-rain-zap-02',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'obligaciones-patronales',
	// 	title: 'Obligaciones patronales',
	// 	iconName: 'agreement-01',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'integral-comercio',
	// 	title: 'Integral de comercio',
	// 	iconName: 'package-delivered',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'todo-riesgo-operativo',
	// 	title: 'Todo riesgo operativo',
	// 	iconName: 'configuration-01',
	// 	color: 'green' as const,
	// },
	{
		id: 'responsabilidad-civil',
		title: 'RC Productos',
		iconName: 'safe',
		color: 'green' as const,
		link: '/cotizacion-rc-productos',
	},
	{
		id: 'rc-contratistas',
		title: 'RC Contratistas',
		iconName: 'labor',
		color: 'green' as const,
		link: '/cotizacion-rc-contratistas',
	},
	// {
	// 	id: 'transporte',
	// 	title: 'Transporte',
	// 	iconName: 'bus-01',
	// 	color: 'green' as const,
	// },

	{
		id: 'caucion-igj',
		title: 'Caución IGJ',
		iconName: 'briefcase-09',
		color: 'green' as const,
		link: '/cotizacion-caucion-igj',
	},
	{
		id: 'caucion-aduanera',
		title: 'Caución Aduanera',
		iconName: 'package-delivered',
		color: 'green' as const,
		link: '/cotizacion-caucion-aduanera',
	},
	{
		id: 'caucion-imex',
		title: 'Caución IMEX',
		iconName: 'truck',
		color: 'green' as const,
		link: '/cotizacion-caucion-imex',
	},
	{
		id: 'construccion',
		title: 'Construcción',
		iconName: 'crane',
		color: 'green' as const,
		link: '/cotizacion-todo-riesgo-construccion',
	},
	// {
	// 	id: 'flota',
	// 	title: 'Flota',
	// 	iconName: 'truck',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'mala-praxis',
	// 	title: 'Mala Praxis',
	// 	iconName: 'cardiogram-02',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'credito',
	// 	title: 'Crédito',
	// 	iconName: 'credit-card',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'consorcio',
	// 	title: 'Consorcio',
	// 	iconName: 'building-02',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'incendio',
	// 	title: 'Incendio',
	// 	iconName: 'fire',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'todo-riesgo-coporativo',
	// 	title: 'Todo riesgo Coporativo',
	// 	iconName: 'new-office',
	// 	color: 'green' as const,
	// },
	// {
	// 	id: 'vida-corporativa',
	// 	title: 'Vida corporativa',
	// 	iconName: 'briefcase-09',
	// 	color: 'green' as const,
	// },
	{
		id: 'agro',
		title: 'Integral Agropecuario',
		iconName: 'tractor',
		color: 'green' as const,
		link: '/cotizacion-integral-agropecuario',
	},
	{
		id: 'silobolsa',
		title: 'Silobolsa',
		iconName: 'natural-food',
		color: 'green' as const,
		link: '/cotizacion-silobolsa',
	},
] as InsuranceType[]
